import { ENGLISH_TEST_MESSAGES } from '../../../constants/enrollmentContent'

export function getSubmissionErrorMessage(error: unknown) {
  return error instanceof Error ? error.message : ENGLISH_TEST_MESSAGES.answerSubmitFailed
}
